import GeneralForms from './generalForms';
import DealerForm from './dealerForm';
import UserForm from './userForm';
import InformationForm from './informationForm';
import CustomerAddresses from './addressForm';
import CustomerUser from './authoriesForm';
import CustomerSubscription from './subscriptionForm';

export default {
    GeneralForms, DealerForm, UserForm, InformationForm, CustomerAddresses, CustomerUser, CustomerSubscription
}


// WEBPACK FOOTER //
// ./src/pages/General/Customer/forms/index.js